module.exports = __webpack_public_path__ + "img/diagonal-bottom-left.20b6a415.png";